// extracted by mini-css-extract-plugin
module.exports = {"tabs":"styles-module--tabs--2XLO2","tabs__item":"styles-module--tabs__item--UqbFw"};